import React from "react";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { useEffect } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import CloseIcon from "@mui/icons-material/Close";
import moment from "moment";
import "../../../Component/Common/ReuseableComponent/ReuseableComponent.css";
import {
  fDummyFunction,
  GridDataColumn,
} from "../../../Component/Common/ReuseableComponent/Action";
import {
  CmpInputField,
  CmpDatePickerFieldSearch,
  CmpButton,
} from "../../../Component/Common/ToolBox/ToolBox.js";

import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch";
import Modal from "@mui/material/Modal";
import GCTitleSticky from "../../../Component/Common/ReuseableComponent/GCTitleSticky.jsx";

const GCSearcgSalesOrder = ({
  open = false,
  xStatusArr = [],
  xLocationArr = [],
  xGetSearchValue,
  fonChangeStatusModal,
  fonChangeVocNoModal,
  fOnChangeDateModel,
  fonChangePartyModal,
  fonChangeLocModal,
  fonChangeRefNoModal,
  fCloseSearchModal,
  fClearSearchModal,
  GridSearchHeadRowData = [],
  GridDataColumnsSearch = [],
  xOnCellKeyDownSearch,
  xOnRowClickSearch,
  vMediaQuery = false,
  xEnterObj = "",
  xTitle = "",
  xStatusVal = "",
  xVocNoVal = "",
  xPostDtVal = new Date(),
  xLocVal = "",
  xRefNoVal = "",
  xSalesGroupVal = "",
  xPartyVal = "",
  xPartyNameVal = "",
  //Freight

  xGCSearchBtn_ToggleArr = ["Any", "Code", "Name"],
  xfGCSearchBtn_Name,
  xGCSearchBtn_Toggle = false,
  xGCSearchBtn_onKeyUp,
  xGCSearchBtn_SearchDropdownObj,
  xGCSearchBtn_Dropdown_onChange,
  xGCSearchBtn_Dropdown_OnKeyUp_Load,
  xGCSearchBtn_Columns_DropdownSearch,
  xGCSearchBtn_GridData,
  xfGCSearchBtn_OnRowClick,
  xfGCSearchBtn_OnCellKeyDown,
}) => {
  const fCheckKey = (event) => {
    setTimeout(() => {
      if (event.keyCode === 40 && GridSearchHeadRowData.length > 0) {
        var selectedLength =
          document.getElementsByClassName("Mui-selected").length;
        if (selectedLength === 0) {
          let tabel = document.getElementById("table-main-grid-4");
          tabel
            ?.getElementsByClassName("MuiDataGrid-row")[0]
            .firstChild?.focus();
        }
      }
    }, 500);
  };

  return (
    <Modal
      open={open}
      onClose={fCloseSearchModal}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <div className="container-fluid">
        <Box sx={{ overflow: "auto" }} className="model-GCSearchBtn">
        <GCTitleSticky title={xTitle} onClose={fCloseSearchModal} />
        
          
          <div className="p-2">
            <Grid container spacing={0.5} columns={{ xs: 12, sm: 12, md: 12 }}>
              <Grid
                item
                xs={3}
                sm={3}
                md={1}
                className="GCSearchBtn-label txt-overflow-ellipse"
              >
                Status
              </Grid>
              <Grid item xs={9} sm={9} md={5} className="GCSearchBtn-label">
                <select
                  className="form-select form-select-sm"
                  name="Status"
                  value={xStatusVal}
                  onKeyUp={
                    !!xGetSearchValue
                      ? (e) => {
                          xGetSearchValue(e);
                          fCheckKey(e);
                        }
                      : fDummyFunction
                  }
                  onChange={
                    !!fonChangeStatusModal
                      ? (e) => {
                          fonChangeStatusModal(e, xStatusArr);
                        }
                      : fDummyFunction
                  }
                >
                  {xStatusArr.length > 0 ? (
                    <>
                      {" "}
                      {xStatusArr?.map((value, index) => (
                        <option
                          className="py-2"
                          value={value}
                          key={"WmsStatus" + index}
                        >
                          {value}
                        </option>
                      ))}{" "}
                    </>
                  ) : (
                    <option value="">none</option>
                  )}
                </select>
              </Grid>
              <Grid
                item
                xs={3}
                sm={3}
                md={1}
                className="GCSearchBtn-label txt-overflow-ellipse"
              >
                Ref.No
              </Grid>
              <Grid item xs={9} sm={9} md={5} className="GCSearchBtn-label">
                <input
                  className="form-control form-control-sm"
                  autoComplete="off"
                  type="text"
                  name="RefNo"
                  value={xRefNoVal}
                  onKeyUp={
                    !!xGetSearchValue
                      ? (e) => {
                          xGetSearchValue(e);
                          fCheckKey(e);
                        }
                      : fDummyFunction
                  }
                  onChange={
                    !!fonChangeRefNoModal
                      ? (e) => {
                          fonChangeRefNoModal(e);
                        }
                      : fDummyFunction
                  }
                />
              </Grid>
              <Grid
                item
                xs={3}
                sm={3}
                md={1}
                className="GCSearchBtn-label txt-overflow-ellipse"
              >
                Doc.Date
              </Grid>
              <Grid item xs={9} sm={9} md={5} className="GCSearchBtn-label">
                {/* <input
                className="form-control form-control-sm"
                type="date"
                name="PostDt"
                value={moment(xPostDtVal).format("YYYY-MM-DD")}
                onKeyUp={
                  !!xGetSearchValue
                    ? (e) => {
                        xGetSearchValue(e);
                        fCheckKey(e);
                      }
                    : fDummyFunction
                }
                onChange={
                  !!fOnChangeDateModel
                    ? (e) => {
                        fOnChangeDateModel(e);
                      }
                    : fDummyFunction
                }
              /> */}
                <CmpDatePickerFieldSearch
                  xtabIndex={"2"}
                  xValue={xPostDtVal}
                  xOnChange={
                    !!fOnChangeDateModel
                      ? (e) => {
                          fOnChangeDateModel(e);
                        }
                      : fDummyFunction
                  }
                  xName={"PostDt"}
                  xError={false}
                  xErrorMessage={""}
                  xOnKeyUp={
                    !!xGetSearchValue
                      ? (e) => {
                          xGetSearchValue(e);
                        }
                      : fDummyFunction
                  }
                />
              </Grid>
              <Grid
                item
                xs={3}
                sm={3}
                md={1}
                className="GCSearchBtn-label txt-overflow-ellipse"
              >
                Location
              </Grid>
              <Grid item xs={9} sm={9} md={5} className="GCSearchBtn-label">
                <select
                  className="form-select form-select-sm"
                  name="Loc"
                  value={xLocVal}
                  onKeyUp={
                    !!xGetSearchValue
                      ? (e) => {
                          xGetSearchValue(e);
                        }
                      : fDummyFunction
                  }
                  onChange={
                    !!fonChangeLocModal
                      ? (e) => {
                          fonChangeLocModal(e, xLocationArr);
                        }
                      : fDummyFunction
                  }
                >
                  {xLocationArr?.length > 0 ? (
                    <>
                      {" "}
                      {xLocationArr?.map((option, index) => (
                        <option
                          className="py-2"
                          value={option.UId}
                          key={"Location" + index}
                        >
                          {option.Name1}
                        </option>
                      ))}{" "}
                    </>
                  ) : (
                    <option value="">none</option>
                  )}
                </select>
              </Grid>
              <Grid
                item
                xs={3}
                sm={3}
                md={1}
                className="GCSearchBtn-label txt-overflow-ellipse"
              >
                Doc.No
              </Grid>
              <Grid item xs={9} sm={9} md={5} className="GCSearchBtn-label">
                <input
                  className="form-control form-control-sm"
                  autoComplete="off"
                  type="text"
                  name="VocNo"
                  value={xVocNoVal}
                  onKeyUp={
                    !!xGetSearchValue
                      ? (e) => {
                          xGetSearchValue(e);
                          fCheckKey(e);
                        }
                      : fDummyFunction
                  }
                  onChange={
                    !!fonChangeVocNoModal
                      ? (e) => {
                          fonChangeVocNoModal(e);
                        }
                      : fDummyFunction
                  }
                />
              </Grid>

              <Grid
                item
                xs={3}
                sm={3}
                md={1}
                className="GCSearchBtn-label txt-overflow-ellipse"
              >
                Customer
              </Grid>
              <Grid
                item
                xs={1}
                sm={1}
                md={1}
                className="xs-dontShowInMobileView"
              >
                <CmpInputField
                  xValue={xPartyVal}
                  xType={"text"} // text/number/password
                  xName={"GCSearchBtn_Code"}
                  xReadOnly={true}
                  xOnChange={""}
                  xError={false}
                  xErrorMessage={""}
                  xOnKeyUp={""}
                />
              </Grid>
              <Grid item xs={9} sm={8} md={4}>
                <GCToggleSearch
                  xName={"GCSearchBtn_Name"}
                  xType={"text"}
                  xValue={xPartyNameVal}
                  xReadOnly={false}
                  xOnChange={
                    !!xfGCSearchBtn_Name ? xfGCSearchBtn_Name : fDummyFunction
                  } //GCToggleSearch onchange main input
                  xOnKeyUp={xGCSearchBtn_onKeyUp} //GCToggleSearch xOnKeyUp main input
                  xError={false}
                  xErrorMessage={""}
                  xMediaQuery={false}
                  xonClickbtn={
                    !!xGCSearchBtn_onKeyUp
                      ? xGCSearchBtn_onKeyUp
                      : fDummyFunction
                  } // GCToggleSearch onclick icon open div on main screen
                  xrows={xGCSearchBtn_GridData} //GCToggleSearch-grid
                  xcolumns={xGCSearchBtn_Columns_DropdownSearch} //GCToggleSearch-grid
                  xRowCellClick={xfGCSearchBtn_OnCellKeyDown}
                  xRowClick={xfGCSearchBtn_OnRowClick}
                  xToggle={xGCSearchBtn_Toggle} //GCToggleSearch- true/false
                  xData={xGCSearchBtn_ToggleArr} //GCToggleSearch-select
                  xOnChangeDropdownInput={xGCSearchBtn_Dropdown_onChange} //GCToggleSearch -input
                  xDropdownObj={xGCSearchBtn_SearchDropdownObj} //GCToggleSearch -obj
                  xOnKeyUpDropdownInput={xGCSearchBtn_Dropdown_OnKeyUp_Load} //GCToggleSearch -Enter key and clickc detect
                  xtabIndex="2002"
                />
              </Grid>
              <Grid
                item
                xs={3}
                sm={3}
                md={1}
                className="xs-dontShowInMobileView"
              ></Grid>
              <Grid item xs={12} sm={12} md={12}>
                <Grid
                  container
                  spacing={1}
                  columns={{ xs: 12, sm: 12, md: 12 }}
                  justifyContent={vMediaQuery ? "center" : "end"}
                >
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={1}
                    className="GCSearchBtn-label "
                  >
                    <CmpButton
                      xbtnName="Load"
                      xOnClick={(e) => xGetSearchValue(xEnterObj)}
                      xVariant="contained"
                      xDisabled={false}
                      xSize="small"
                    />
                    {/* <button
                    className="btn btn-primary"
                    onClick={
                      !!xGetSearchValue
                        ? (e) => {
                            xGetSearchValue(xEnterObj);
                          }
                        : fDummyFunction
                    }
                  >
                    Load
                  </button> */}
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={1}
                    className="GCSearchBtn-label "
                  >
                    <CmpButton
                      xbtnName="Clear"
                      xOnClick={(e) => fClearSearchModal(e)}
                      xVariant="contained"
                      xDisabled={false}
                      xSize="small"
                    />
                    {/* <button
                    className="btn btn-primary"
                    onClick={
                      !!fClearSearchModal
                        ? (e) => {
                            fClearSearchModal(e);
                          }
                        : fDummyFunction
                    }
                  >
                    Clear
                  </button> */}
                  </Grid>
                  <Grid
                    item
                    xs={4}
                    sm={4}
                    md={1}
                    className="GCSearchBtn-label "
                  >
                    <CmpButton
                      xbtnName="Cancel"
                      xOnClick={(e) => {
                        fCloseSearchModal(e);
                        fClearSearchModal(e);
                      }}
                      xVariant="contained"
                      xDisabled={false}
                      xSize="small"
                    />
                    {/* <button
                    className="btn btn-primary"
                    onClick={
                      !!fCloseSearchModal
                        ? (e) => {
                            fCloseSearchModal(e);
                            fClearSearchModal(e);
                          }
                        : fDummyFunction
                    }
                  >
                    Cancel
                  </button> */}
                  </Grid>
                </Grid>
              </Grid>
            </Grid>

            <Grid container spacing={1} columns={{ xs: 4, sm: 4, md: 12 }}>
              <Grid item xs={12} className="GCSearchBtn-label mt-2">
                <div
                  style={{
                    height: vMediaQuery ? "45vh" : "58vh",
                    width: "100%",
                  }}
                  id="table-main-grid-4"
                >
                  <DataGrid
                    rowHeight={30}
                    headerHeight={40}
                    getRowClassName={(params) =>
                      params.indexRelativeToCurrentPage % 2 === 0
                        ? "mui-even-row"
                        : "mui-odd-row"
                    }
                    sx={{
                      border: 1,
                      borderColor: "primary.light",
                    }}
                    rows={GridSearchHeadRowData}
                    columns={
                      GridDataColumnsSearch
                        ? GridDataColumnsSearch
                        : GridDataColumn
                    }
                    onCellKeyDown={xOnCellKeyDownSearch}
                    onRowClick={xOnRowClickSearch}
                    hideFooter={GridSearchHeadRowData.length < 100}
                    // components={{
                    //   Toolbar: GridToolbar,
                    // }}
                  />
                </div>
              </Grid>
            </Grid>
          </div>
        </Box>
      </div>
    </Modal>
  );
};

export default GCSearcgSalesOrder;
